// assets
import { ReactComponent as Course} from '../assets/navigation-icons/course.svg';
import FeedIcon from '@mui/icons-material/Feed';
import DashboardIcon from '@mui/icons-material/WidgetsRounded';

const LargeDashboardIcon = (props) => (
    <DashboardIcon
        {...props}
        sx={{
            fontSize: '23px !important',
            marginLeft: '-1px'
        }}
    />
);

const NewsFeedIcon = (props) => (
    <FeedIcon
        {...props}
        sx={{
            fontSize: '24px !important',
            marginLeft: '-1px'
        }}
    />
);


// icons
const icons = {
    Course,
    FeedIcon: NewsFeedIcon,
    DashboardIcon: LargeDashboardIcon
};
// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const userItems = {
    id: 'userItems',
    type: 'group',
    title: 'User',
    divider: false,
    children: [
        {
            id: 'dashboard1',
            title: 'Dashboard',
            type: 'item',
            url: '/',
            icon: icons.DashboardIcon,
        },
        {
            id: 'feed1',
            title: 'News Feed',
            type: 'item',
            url: '/feed',
            icon: icons.FeedIcon,
        },
    ]
};

export default userItems;
